import React from 'react'
import DefaultLayout from './layout/DefaultLayout'

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const Dashboard = React.lazy(() => import('./views/dashboard'))
const ListStateMachine = React.lazy(() => import('./views/statemachine/list'))
const DetailStateMachine = React.lazy(() => import('./views/statemachine/detail'))
const RealTimeStateMachine = React.lazy(() => import('./views/statemachine/real-time'))
const ListContent = React.lazy(() => import('./views/content/list'))
const DetailContent = React.lazy(() => import('./views/content/detail'))

const routes = [
  { path: '/', name: 'Login', element: <Login /> },
  { path: '/login', name: 'Login', element: <Login /> },
  { path: '/page-500', name: 'Page 500', element: <Page500 /> },
  { path: '/page-404', name: 'Page 404', element: <Page404 /> },
  { path: '/register', name: 'Register', element: <Register /> },
  {
    path: '/dashboard',
    name: 'Dashboard',
    element: (
      <DefaultLayout>
        <Dashboard />
      </DefaultLayout>
    ),
  },
  {
    path: '/statemachine/list',
    name: 'State Machine',
    element: (
      <DefaultLayout>
        <ListStateMachine />
      </DefaultLayout>
    ),
  },
  {
    path: '/statemachine/detail',
    name: 'State Machine Detail',
    element: (
      <DefaultLayout>
        <DetailStateMachine />
      </DefaultLayout>
    ),
  },
  {
    path: '/statemachine/real-time',
    name: 'State Machine Real Time',
    element: (
      <DefaultLayout>
        <RealTimeStateMachine />
      </DefaultLayout>
    ),
  },
  {
    path: '/content/list',
    name: 'Content',
    element: (
      <DefaultLayout>
        <ListContent />
      </DefaultLayout>
    ),
  },
  {
    path: '/content/detail',
    name: 'Content Detail',
    element: (
      <DefaultLayout>
        <DetailContent />
      </DefaultLayout>
    ),
  },
]

export default routes
